import { SkeletonLine } from './SkeletonLine.jsx';

export function ReportsSkeleton({ label }) {
  return (
    <div className="space-y-3">
      <style>{`@keyframes empireSkeleton {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }`}</style>
      {label && <div className="text-xs text-gray-400">{label}</div>}
      <div className="card">
        <SkeletonLine w="40%" h={18} />
        <SkeletonLine w="60%" h={12} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginTop: 12 }}>
          {[0,1,2,3].map(i => <div key={i}><SkeletonLine w="50%" h={11} /><SkeletonLine w="80%" h={22} mb={0} /></div>)}
        </div>
      </div>
      <div className="card">
        <SkeletonLine w="30%" h={14} />
        <SkeletonLine h={120} mb={0} />
      </div>
      <div className="card">
        <SkeletonLine w="35%" h={14} />
        <SkeletonLine h={80} mb={0} />
      </div>
    </div>
  );
}
